// ChangePasswordForm.jsx
import React, { useState } from "react";
import { changeTeacherPassword } from "../../ApiController/teacherApi";
import "bootstrap/dist/css/bootstrap.min.css";
import { validatePassword } from "./validatePassword";

const ChangePasswordForm = ({ showTeacherId }) => {
	const [formData, setFormData] = useState({
		teacherId: "",
		newPassword: "",
		confirmPassword: "",
	});

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		// Använd 'teacherId' från formuläret eller 'sessionStorage'
		const userId = showTeacherId
			? formData.teacherId
			: sessionStorage.getItem("userId");
		// Kontrollera om lösenorden matchar
		const validationError = validatePassword(
			formData.newPassword,
			formData.confirmPassword,
			userId
		);
		if (validationError) {
			alert(validationError);
			return;
		}

		try {
			// API-anrop för att ändra lösenord
			await changeTeacherPassword(userId, formData.newPassword);
			alert("Lösenordet har ändrats.");
			// Rensa formuläret
			setFormData({
				teacherId: "",
				newPassword: "",
				confirmPassword: "",
			});
		} catch (error) {
			console.error("Misslyckades med att ändra lösenord:", error);
			if (error.response && error.response.data && error.response.data.error) {
				alert(error.response.data.error); // Visa serverns felmeddelande
			} else {
				alert("Misslyckades med att ändra lösenord.");
			}
		}
	};

	return (
		<div>
			<div className="d-flex justify-content-around mb-4">
				<div className="card custom-card-fixed-width">
					<div className="card-body">
						<form onSubmit={handleSubmit}>
							{showTeacherId && (
								<div className="mb-3">
									<label htmlFor="teacherId">Lärar-ID</label>
									<input
										type="text"
										className="form-control"
										id="teacherId"
										name="teacherId"
										value={formData.teacherId}
										onChange={handleInputChange}
										required
									/>
								</div>
							)}
							<div className="mb-3">
								<label htmlFor="newPassword">Nytt Lösenord</label>
								<input
									type="password"
									className="form-control"
									id="newPassword"
									name="newPassword"
									value={formData.newPassword}
									onChange={handleInputChange}
									required
								/>
							</div>
							<div className="mb-3">
								<label htmlFor="confirmPassword">Bekräfta Nytt Lösenord</label>
								<input
									type="password"
									className="form-control"
									id="confirmPassword"
									name="confirmPassword"
									value={formData.confirmPassword}
									onChange={handleInputChange}
									required
								/>
							</div>
							<div className="flex-grow-1 d-flex justify-content-center">
								<button type="submit" className="btn btn-primary btn-narrow">
									Ändra Lösenord
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ChangePasswordForm;
